export default __webpack_public_path__ + "static/group-11549-822c96d1653aa516577389c2fd0b53b7.png";